import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
const service = axios.create({
    baseURL: "/aicourse",
    timeout: 120000,
});
export default service;
